import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  MenuItem,
  Select,
  TextField,
  Typography,
  Paper,
  Grid,
} from "@mui/material";
import CommonTable2, {
  type Column,
} from "../../components/CommonTable/CommonTable2";
import { useDispatch, useSelector } from "react-redux";
import { useAppSelector } from "../../../Redux/Store/Hooks";
import { ClassSelectionDataRead } from "../../../Redux/Slices/Booklet/Tutor/ClassSelection/Class selection page/ClassSelectionData";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import weekOfYear from "dayjs/plugin/weekOfYear";
import { PreviousClass_CRUDRead } from "../../../Redux/Slices/Booklet/Tutor/ClassSelection/Class selection page/PreviousClass_CRUD";
import { PreviousClassRead } from "../../../Redux/Slices/Booklet/Tutor/ClassSelection/Class selection page/PreviousClassRead";
import { useNavigate } from "react-router-dom";

dayjs.extend(weekOfYear);

interface RowData {
  centre: string;
  yearGroup: string;
  subject: string;
  date: string;
  [key: string]: unknown;
}

const ClassSelection: React.FC = () => {
  const [date, setDate] = useState("");
  const [center, setCenter] = useState<any>(null);
  const [yearGroup, setYearGroup] = useState<string | number>("");
  const [subject, setSubject] = useState<any>(null);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { data: ClassSelectionData } = useAppSelector(
    (state) => state.ClassSelectionData
  );
  const { data: PreviousClassData, isLoading: PreviousClassLoading } =
    useAppSelector((state) => state.PreviousClass_Read);

  const { data: PreviousClassAdd, isLoading: PreviousClassLoadingadd } =
    useAppSelector((state) => state.PreviousClass_CRUD);

  const data = PreviousClassData?.data;

  const previousRows: RowData[] = Array.isArray(data)
    ? data.map((item: any) => ({
        date: dayjs(item.date).format("DD-MMM-YYYY"),
        centre: item.center_data?.center_name || "-",
        yearGroup: item.yeargroup_id || "-",
        subject: item.subject_data?.name || "-",
      }))
    : [];

  useEffect(() => {
    dispatch(ClassSelectionDataRead({}));
    dispatch(PreviousClassRead());
  }, []);

  const handleYearGroupChange = (yeargroup_id: number | string) => {
  if (yeargroup_id) {
    dispatch(ClassSelectionDataRead({ yeargroup_id }));
  }
};


  // const handleYearGroupChange = (value: string) => {
  //   setYearGroup(value);

  //   const selectedYear =
  //     ClassSelectionData?.data?.yeargroup_region_mappings?.find(
  //       (y: any) => y.id === value
  //     );

  //   if (selectedYear) {
  //     dispatch(ClassSelectionDataRead({ yeargroup_id: selectedYear.id }));
  //   }
  // };

  const validateForm = () => {
    if (!center) {
      alert("Please select Center");
      return false;
    }
    if (!yearGroup) {
      alert("Please select Year Group");
      return false;
    }
    if (!subject) {
      alert("Please select Subject");
      return false;
    }
    if (!date) {
      alert("Please select Date");
      return false;
    }

    return true;
  };




  const handleSubmit = () => {
    if (!validateForm()) return;

    const selectedData = {
      center_id: center?.center_id,
      center_name: center?.center_name,

      yeargroup_id: selectedYearGroup?.id,
      yeargroup_name: selectedYearGroup?.concatenated_name,

      subject_id: subject?.id,
      subject_name: subject?.name,

      date: date,
    };



    const payload = {
      previou_class_selection_id: "",
      ...selectedData,
      status: true,
      is_delete: false,
    };

    console.log("Submit Payload →", payload);

    dispatch(PreviousClass_CRUDRead(payload));

    navigate("/study_materials", { state: selectedData });

    setCenter("");
    setYearGroup("");
    setSubject("");
    setDate("");
  };

  const centers = ClassSelectionData?.data?.centers || [];
  const yearGroups = ClassSelectionData?.data?.yeargroup_region_mappings || [];
  const subjects = ClassSelectionData?.data?.subjects || [];

    const selectedYearGroup = yearGroups.find((y: any) => y.id === yearGroup);
  const columns: Column[] = [
    // { field: "week", headerName: "Week", fontWeight: 400, align: "left" },
    { field: "date", headerName: "Date", fontWeight: 400, align: "left" },
    { field: "centre", headerName: "Centre", fontWeight: 400, align: "left" },
    {
      field: "yearGroup",
      headerName: "Year Group",
      fontWeight: 400,
      align: "left",
    },
    { field: "subject", headerName: "Subject", fontWeight: 400, align: "left" },
  ];

  return (
    <Box bgcolor="#f7f9fb" height="100%">
      <Grid container spacing={2} height={"100%"}>
        {/* LEFT PANEL */}
        <Grid item xs={12} sm={12} md={4} lg={4} height={"100%"}>
          <Paper
            sx={{ p: { xs: 2, sm: 3 }, borderRadius: "12px", height: "100%" }}
          >
            <Typography variant="h6" fontWeight={600} fontSize="16px" mb={1}>
              Class Selection
            </Typography>
            <Typography variant="body2" mb={3}>
              Select your Class
            </Typography>

            <Box
              sx={{
                maxWidth: "70%",
                width: "100%",
              }}
            >
              {/* Center */}
              <Typography variant="body2" fontSize="14px" mb={0.5}>
                Center
              </Typography>
              <Select
                value={center?.center_id || ""}
                onChange={(e) => {
                  const selected = centers.find(
                    (c: any) => c.center_id === e.target.value
                  );
                  setCenter(selected);
                }}
                fullWidth
                sx={{ mb: 2 }}
              >
                <MenuItem value="">
                  <em>Select Center</em>
                </MenuItem>
                {centers.map((c: any) => (
                  <MenuItem key={c.center_id} value={c.center_id}>
                    {c.center_name}
                  </MenuItem>
                ))}
              </Select>

              {/* Year Group */}
              <Typography variant="body2" fontSize="14px" mb={0.5}>
                Year Group
              </Typography>
              <Select
                value={yearGroup}
                onChange={(e) => {
                  const selectedId = e.target.value;
                  setYearGroup(selectedId);
                  handleYearGroupChange(selectedId);
                }}
                fullWidth
                sx={{ mb: 2 }}
              >
                <MenuItem value="">
                  <em>Select Year Group</em>
                </MenuItem>

                {yearGroups.map((yg: any) => (
                  <MenuItem key={yg.id} value={yg.id}>
                    {yg.concatenated_name}
                  </MenuItem>
                ))}
              </Select>

              {/* Subject */}
              <Typography variant="body2" fontSize="14px" mb={0.5}>
                Subject
              </Typography>
              <Select
                value={subject?.id || ""}
                onChange={(e) => {
                  const selected = subjects.find(
                    (s: any) => s.id === e.target.value
                  );
                  setSubject(selected);
                }}
                fullWidth
                sx={{ mb: 2 }}
              >
                <MenuItem value="">
                  <em>Select Subject</em>
                </MenuItem>
                {subjects.length > 0 &&
                  subjects.map((s: any) => (
                    <MenuItem key={s.id} value={s.id}>
                      {s.name}
                    </MenuItem>
                  ))}
              </Select>

              {/* Day */}
              {/* Date */}
              <Typography variant="body2" fontSize="14px" mb={0.5}>
                Date
              </Typography>

              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  value={date ? dayjs(date) : null}
                  minDate={dayjs().startOf("day")}
                  onChange={(d) => setDate(d ? d.toISOString() : "")}
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      sx: { mb: 2 },
                    },
                  }}
                  sx={{
                    // SELECTED DAY BLUE
                    "& .MuiPickersDay-root.Mui-selected": {
                      backgroundColor: "#009DFF !important",
                      color: "#fff !important",
                    },

                    // HOVER ON SELECTED DAY
                    "& .MuiPickersDay-root.Mui-selected:hover": {
                      backgroundColor: "#007ACC !important",
                    },

                    // HOVER ON NORMAL DAYS
                    "& .MuiPickersDay-root:not(.Mui-selected):hover": {
                      backgroundColor: "rgba(0,157,255,0.2) !important",
                    },

                    // TODAY WITH BORDER (optional)
                    "& .MuiPickersDay-root.MuiPickersDay-today": {
                      border: "1px solid #009DFF !important",
                    },
                  }}
                />
              </LocalizationProvider>
            </Box>

            <Box display="flex" justifyContent="flex-end" mt={1}>
              <Button
                variant="contained"
                onClick={handleSubmit}
                sx={{
                  fontSize: "12px",
                  color: "#ffffff",
                  bgcolor: "#009DFF",
                  borderRadius: "8px",
                  maxWidth: "40%",
                  textTransform: "none",
                  borderColor: "#009DFF",
                  "&:hover": {
                    opacity: 0.8,
                    bgcolor: "#009DFF",
                  },
                }}
              >
                Proceed to Booklet
              </Button>
            </Box>
          </Paper>
        </Grid>

        {/* RIGHT PANEL */}
        <Grid item xs={12} sm={12} md={8} lg={8}>
          <Paper
            sx={{
              p: { xs: 2, sm: 3 },
              borderRadius: "12px",
              maxHeight: "820px",
              height: "100%",
            }}
          >
            <Typography variant="h6" fontSize="16px" fontWeight={600} mb={3}>
              Previous Class Selections
            </Typography>
            <CommonTable2
              columns={columns}
              rows={previousRows}
              loading={PreviousClassLoading}
            />
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ClassSelection;
